// // SmsMaster.jsx
// import React, { useState, useEffect, useRef } from "react";
// import "../assets/SmsMaster.css";
// const SmsMaster = () => {
//   const [templates, setTemplates] = useState([]);
//   const [formData, setFormData] = useState({
//     templateName: "",
//     templateId: "",
//     senderId: "",
//     messageId: "",
//     variables: "",
//     message: "",
//     active: false,
//     assignUser: "",
//   });
//   const [editingIndex, setEditingIndex] = useState(null);
//   const messageRef = useRef(null);

//   // Auto expand textarea as user types
//   useEffect(() => {
//     if (messageRef.current) {
//       messageRef.current.style.height = "auto";
//       messageRef.current.style.height = messageRef.current.scrollHeight + "px";
//     }
//   }, [formData.message]);

//   // Word count limit max 100 words
//   const handleMessageChange = (e) => {
//     const words = e.target.value.split(/\s+/).filter(Boolean);
//     if (words.length <= 100) {
//       setFormData({ ...formData, message: e.target.value });
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     if (type === "checkbox") {
//       setFormData({ ...formData, [name]: checked });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (
//       !formData.templateName.trim() ||
//       !formData.templateId.trim() ||
//       !formData.senderId.trim() ||
//       !formData.messageId.trim()
//     ) {
//       alert("Please fill in all required fields.");
//       return;
//     }

//     if (editingIndex !== null) {
//       // Update existing
//       const updatedTemplates = [...templates];
//       updatedTemplates[editingIndex] = { ...formData };
//       setTemplates(updatedTemplates);
//       setEditingIndex(null);
//     } else {
//       // Add new
//       setTemplates([...templates, { ...formData }]);
//     }

//     // Reset form
//     setFormData({
//       templateName: "",
//       templateId: "",
//       senderId: "",
//       messageId: "",
//       variables: "",
//       message: "",
//       active: false,
//       assignUser: "",
//     });
//   };

//   const handleEdit = (index) => {
//     setEditingIndex(index);
//     setFormData(templates[index]);
//   };

//   const handleAssignChange = (e, index) => {
//     const value = e.target.value;
//     const updatedTemplates = [...templates];
//     updatedTemplates[index].assignUser = value;
//     setTemplates(updatedTemplates);
//   };

//   const handleSaveAssign = (index) => {
//     alert(
//       `Assign saved for template "${templates[index].templateName}": User = ${templates[index].assignUser}`
//     );
//   };

//   return (
//     <div className="SmsMaster-container">
//       <section className="SmsMaster-section SmsMaster-master">
//         <h2 className="SmsMaster-title-top">SMS Template Master</h2>
//         <form className="SmsMaster-form" onSubmit={handleSubmit} noValidate>
//           <div className="SmsMaster-row">
//             <label htmlFor="templateName">Enter Template Name</label>
//             <input
//               id="templateName"
//               name="templateName"
//               type="text"
//               value={formData.templateName}
//               onChange={handleInputChange}
//               placeholder="Template Name"
//               required
//               className="SmsMaster-input"
//             />
//           </div>

//           <div className="SmsMaster-row">
//             <label htmlFor="templateId">Enter Template ID</label>
//             <input
//               id="templateId"
//               name="templateId"
//               type="text"
//               value={formData.templateId}
//               onChange={handleInputChange}
//               placeholder="Template ID"
//               required
//               className="SmsMaster-input"
//             />
//           </div>

//           <div className="SmsMaster-row">
//             <label htmlFor="senderId">Sender ID</label>
//             <input
//               id="senderId"
//               name="senderId"
//               type="text"
//               value={formData.senderId}
//               onChange={handleInputChange}
//               placeholder="Sender ID"
//               required
//               className="SmsMaster-input"
//             />
//           </div>

//           <div className="SmsMaster-row">
//             <label htmlFor="messageId">Message ID</label>
//             <input
//               id="messageId"
//               name="messageId"
//               type="text"
//               value={formData.messageId}
//               onChange={handleInputChange}
//               placeholder="Message ID"
//               required
//               className="SmsMaster-input"
//             />
//           </div>

//           <div className="SmsMaster-row">
//             <label htmlFor="variables">Variables (e.g., #var1 | #var2)</label>
//             <input
//               id="variables"
//               name="variables"
//               type="text"
//               value={formData.variables}
//               onChange={handleInputChange}
//               placeholder="#var1 | #var2"
//               className="SmsMaster-input"
//             />
//           </div>

//           <div className="SmsMaster-row SmsMaster-message-row">
//             <label htmlFor="message">Template Message (max 100 words)</label>
//             <textarea
//               id="message"
//               name="message"
//               ref={messageRef}
//               value={formData.message}
//               onChange={handleMessageChange}
//               placeholder="Enter your message here..."
//               className="SmsMaster-textarea"
//               rows={1}
//             />
//             <small className="SmsMaster-wordcount">
//               {formData.message.trim().split(/\s+/).filter(Boolean).length} / 100
//               words
//             </small>
//           </div>

//           <div className="SmsMaster-row SmsMaster-active-row">
//             <label htmlFor="active">Active</label>
//             <input
//               id="active"
//               name="active"
//               type="checkbox"
//               checked={formData.active}
//               onChange={handleInputChange}
//               className="SmsMaster-checkbox"
//             />
//           </div>

//           <button type="submit" className="SmsMaster-submit">
//             {editingIndex !== null ? "Update Template" : "Submit"}
//           </button>
//         </form>
//       </section>

//       <section className="SmsMaster-section SmsMaster-report">
//   <h2 className="SmsMaster-title">SMS Template Report</h2>
//   <div className="SmsMaster-table-container">
//     <table className="SmsMaster-table" role="table" aria-label="SMS Template Report">
//       <thead>
//         <tr>
//           <th>Serial No.</th>
//           <th>Template Name</th>
//           <th>Template ID</th>
//           <th>Sender ID</th>
//           <th>Message ID</th>
//           <th>Variables</th>
//           <th>Message</th>
//           <th>Status</th>
//           <th>Edit</th>
//           <th>Assign</th>
//           <th>Save</th>
//         </tr>
//       </thead>
//       <tbody>
//         {templates.length === 0 ? (
//           <tr className="SmsMaster-no-data-row">
//             <td colSpan="11" className="SmsMaster-no-data">
//               No templates added yet.
//             </td>
//           </tr>
//         ) : (
//           templates.map((tpl, idx) => (
//             <tr key={idx}>
//               <td>{idx + 1}</td>
//               <td>{tpl.templateName||"N/A"}</td>
//               <td>{tpl.templateId||"N/A"}</td>
//               <td>{tpl.senderId||"N/A"}</td>
//               <td>{tpl.messageId||"N/A"}</td>
//               <td>{tpl.variables||"N/A"}</td>
//               <td
//                 className="SmsMaster-message-cell"
//                 title={tpl.message||"N/A"}
//               >
//                 {tpl.message.length > 40
//                   ? tpl.message.slice(0, 37) + "..."
//                   : tpl.message}
//               </td>
//               <td>{tpl.active ? "Active" : "Inactive"}</td>
//               <td>
//                 <button
//                   className="SmsMaster-btn-edit"
//                   onClick={() => handleEdit(idx)}
//                   aria-label={`Edit template ${tpl.templateName}`}
//                 >
//                   Edit
//                 </button>
//               </td>
//               <td>
//                 <select
//                   className="SmsMaster-select"
//                   value={tpl.assignUser || ""}
//                   onChange={(e) => handleAssignChange(e, idx)}
//                   aria-label={`Assign user for template ${tpl.templateName}`}
//                 >
//                   <option value="">Select</option>
//                   <option value="User A">Credit account message</option>
//                   <option value="User B">Debit account message</option>
//                   <option value="User C">Other</option>
//                 </select>
//               </td>
//               <td>
//                 <button
//                   className="SmsMaster-btn-save"
//                   onClick={() => handleSaveAssign(idx)}
//                   aria-label={`Save assignment for template ${tpl.templateName}`}
//                 >
//                   Save
//                 </button>
//               </td>
//             </tr>
//           ))
//         )}
//       </tbody>
//     </table>
//   </div>
//      </section>

//     </div>
//   );
// };

// export default SmsMaster;

// SmsMaster.jsx
import React, { useState, useEffect } from "react";
import "../assets/SmsMaster.css";
import { Edit, Trash } from "lucide-react";
import { toast } from "react-toastify";
import axios from "axios";

const BASE_URL = "https://payyug.in";

const SmsMaster = () => {
  const [templates, setTemplates] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    templateName: "",
    senderId: "",
    messageId: "",
    variableKeys: "",
    variableCount: "",
    active: false,
  });

  // ================= FETCH LIST =================
  const fetchTemplates = async () => {
    try {
      const superAdminId = localStorage.getItem("adminuserId");
      const res = await axios.get(
        `${BASE_URL}/api/smsTemplateController?superAdminId=${superAdminId}`,
      );
      setTemplates(res.data.data || []);
    } catch (err) {
      toast.error("Failed to fetch templates");
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  // ================= INPUT CHANGE =================
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ================= SUBMIT =================
const handleSubmit = async (e) => {
  e.preventDefault();

  if (
    !formData.templateName.trim() ||
    !formData.senderId.trim() ||
    !formData.messageId.trim() ||
    !formData.variableKeys.trim() ||
    !formData.variableCount
  ) {
    toast.warning("Please fill in all required fields.");
    return;
  }

  const keysArray = formData.variableKeys
    .split(",")
    .map(k => k.trim())
    .filter(k => k !== "");

  if (keysArray.length !== Number(formData.variableCount)) {
    toast.warning(
      `You must enter exactly ${formData.variableCount} variable keys`
    );
    return;
  }

  const payload = {
    name: formData.templateName,
    senderId: formData.senderId,
    messageId: formData.messageId,
    messageType: formData.templateName,
    variable_keys: formData.variableKeys,
    var_count: Number(formData.variableCount),
    status: formData.active,
    lock: formData.active ? true : false,
    assign: false,
    superAdminId: Number(localStorage.getItem("adminuserId")),
  };

  try {
    if (editingId) {
      const res = await axios.put(
        `${BASE_URL}/api/smsTemplateController/${editingId}`,
        payload
      );
      toast.success(res.data.message || "SMS Updated Successfully");
    } else {
      const res = await axios.post(
        `${BASE_URL}/api/smsTemplateController/create`,
        payload
      );
      toast.success(res.data.message || "SMS Created Successfully");
    }

    resetForm();
    fetchTemplates();
  } catch (err) {
    toast.error(err?.response?.data?.message || "Something went wrong");
  }
};

  // ================= EDIT =================
  const handleEdit = (item) => {
    setEditingId(item.id);
    setFormData({
      templateName: item.name || "",
      senderId: item.senderId || "",
      messageId: item.messageId || "",
      variableKeys: item.variable_keys || "",
      variableCount: item.var_count || "",
      active: String(item.status) === "1",
    });
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this template?"))
      return;

    try {
      await axios.delete(`${BASE_URL}/api/smsTemplateController/${id}`);
      toast.success("Deleted Successfully");
      fetchTemplates();
    } catch (err) {
      toast.error("Delete failed");
    }
  };

  // ================= RESET =================
  const resetForm = () => {
    setFormData({
      templateName: "",
      senderId: "",
      messageId: "",
      variableKeys: "",
      variableCount: "",
      active: false,
    });
    setEditingId(null);
  };

  return (
    <div className="SmsMaster-container">
      {/* ================= FORM ================= */}
      <section className="SmsMaster-section SmsMaster-master">
        <h2 className="SmsMaster-title-top">SMS Template Master</h2>

        <form className="SmsMaster-form" onSubmit={handleSubmit} noValidate>
          <div className="SmsMaster-row">
            <label>Select Template Name</label>
            <select
              name="templateName"
              value={formData.templateName}
              onChange={handleInputChange}
              required
            >
              <option value="">-- Select Template --</option>
              {[
                "customer_create",
                "apply_loan",
                "disburesd_loan",
                "emi_reminder",
                "Loan_emi_pay",
                "rd_account",
                "dd_account",
                "fd_account",
                "mis_account",
                "RD/DD/FD/MIS payment_Recived",
                "saving_account",
                "saving DR/CR",
                "loan_approvel"
              ].map((temp, index) => (
                <option key={index} value={temp}>
                  {temp}
                </option>
              ))}
            </select>
          </div>

          <div className="SmsMaster-row">
            <label>Sender ID</label>
            <input
              name="senderId"
              type="text"
              value={formData.senderId}
              onChange={handleInputChange}
              placeholder="Sender ID"
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row">
            <label>Message ID</label>
            <input
              name="messageId"
              type="text"
              value={formData.messageId}
              onChange={handleInputChange}
              placeholder="Message ID"
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row">
            <label>Variable Count</label>
            <input
              name="variableCount"
              type="number"
              value={formData.variableCount}
              onChange={handleInputChange}
              placeholder="Variable Count"
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row">
            <label>Variable Keys</label>
            <input
              name="variableKeys"
              type="text"
              value={formData.variableKeys}
              onChange={handleInputChange}
              placeholder={`Enter ${formData.variableCount || ""} keys like key1,key2`}
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row SmsMaster-active-row">
            <label>Active</label>
            <input
              name="active"
              type="checkbox"
              checked={formData.active}
              onChange={handleInputChange}
            />
          </div>

          <button type="submit" className="SmsMaster-submit">
            {editingId ? "Update Template" : "Submit"}
          </button>
        </form>
      </section>

      {/* ================= TABLE ================= */}
      <section className="SmsMaster-section SmsMaster-report">
        <h2 className="SmsMaster-title">SMS Template Report</h2>

        <div className="SmsMaster-table-container">
          <table className="SmsMaster-table">
            <thead>
              <tr>
                <th>Serial No.</th>
                <th>Template Name</th>
                <th>Sender ID</th>
                <th>Message ID</th>
                <th>Variable Keys</th>
                <th>Vairable Count</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {templates.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    No Templates Found
                  </td>
                </tr>
              ) : (
                templates.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.name || "N/A"}</td>
                    <td>{item.senderId || "N/A"}</td>
                    <td>{item.messageId || "N/A"}</td>
                    <td>{item.variable_keys || "N/A"}</td>
                    <td>{item.var_count || "N/A"}</td>
                    <td>{item.status === "1" ? "Active" : "In active"}</td>
                    <td>
                      <div
                        className="sms-master-action-btns"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <button onClick={() => handleEdit(item)}>
                          <Edit color="green" size={20} />
                        </button>
                        <button onClick={() => handleDelete(item.id)}>
                          <Trash color="red" size={20} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default SmsMaster;
